"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const EMPTY_CONFIG = {};
const SearchFormAutocompleteContext = /*#__PURE__*/ createContext(EMPTY_CONFIG);
function SearchFormAutocompleteProvider({ config, children }) {
    return /*#__PURE__*/ jsx(SearchFormAutocompleteContext.Provider, {
        value: config ?? EMPTY_CONFIG,
        children: children
    });
}
function useSearchFormAutocompleteConfig() {
    return useContext(SearchFormAutocompleteContext);
}
const RenderAutocompleteOverrideContext = /*#__PURE__*/ createContext(void 0);
function RenderAutocompleteOverrideProvider({ renderAutocomplete, children }) {
    return /*#__PURE__*/ jsx(RenderAutocompleteOverrideContext.Provider, {
        value: renderAutocomplete,
        children: children
    });
}
function useRenderAutocompleteOverride() {
    return useContext(RenderAutocompleteOverrideContext);
}
export { RenderAutocompleteOverrideProvider, SearchFormAutocompleteProvider, useRenderAutocompleteOverride, useSearchFormAutocompleteConfig };
